import { RawJsonLdData } from 'src/common/store/visualization/VisualizationState';

export function countJsonLdTriples(data: RawJsonLdData[]) {
  return data
    .reduce((triples, node) => {
      if (Array.isArray(node['@graph'])) {
        triples.push(...(node['@graph'] as RawJsonLdData[]));
      } else {
        triples.push(node);
      }
      return triples;
    }, [] as RawJsonLdData[])
    .reduce(
      (count, subject) =>
        Object.keys(subject).reduce((subCount, predicate) => {
          const object = subject[predicate];
          if (predicate === '@id' || !object) {
            return subCount;
          }
          const objectCount = Array.isArray(object) ? object.length : 1;
          return subCount + objectCount;
        }, count),
      0
    );
}
